export default function Footer({ theme = 'warm', text = 'daulton.co' }) {
  const isWexford = theme === 'wexford';

  return (
    <footer
      style={{
        backgroundColor: isWexford ? 'var(--bg-card)' : 'var(--bg-paper)',
        borderTop: `1px solid ${isWexford ? 'var(--border)' : 'var(--border-warm)'}`,
        padding: '1rem',
        textAlign: 'center',
        color: isWexford ? 'var(--text-muted)' : 'var(--text-muted-warm)',
        fontSize: '0.75rem',
        fontFamily: 'var(--font-ui)',
      }}
    >
      <p style={{ margin: 0 }}>{text}</p>
    </footer>
  );
}
